import React, { useState, useEffect } from 'react';
import { emailLogAPI, campaignAPI } from '../api';

function EmailLogs() {
  const [logs, setLogs] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({ campaign_id: '' });

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    loadLogs();
  }, [page, filter]);

  const loadData = async () => {
    try {
      const response = await campaignAPI.getAll();
      if (response.data.success) {
        setCampaigns(response.data.data);
      }
    } catch (error) {
      console.error('加载活动列表失败:', error);
    }
  };

  const loadLogs = async () => {
    try {
      const params = { page, per_page: 50 };
      if (filter.campaign_id) {
        params.campaign_id = filter.campaign_id;
      }

      const response = await emailLogAPI.getAll(params);
      if (response.data.success) {
        setLogs(response.data.data);
        setTotal(response.data.total);
      }
    } catch (error) {
      console.error('加载日志失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { class: 'badge-warning', text: '待发送' },
      sent: { class: 'badge-success', text: '已发送' },
      failed: { class: 'badge-danger', text: '失败' },
      bounced: { class: 'badge-danger', text: '退信' },
    };
    const badge = badges[status] || badges.pending;
    return <span className={`badge ${badge.class}`}>{badge.text}</span>;
  };

  if (loading) {
    return <div>加载中...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>邮件日志</h1>
        <p>查看所有邮件发送记录</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>发送日志 ({total})</h2>
        </div>

        <div style={{ padding: '20px', borderBottom: '1px solid #eee' }}>
          <select
            value={filter.campaign_id}
            onChange={(e) => setFilter({ campaign_id: e.target.value })}
            style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }}
          >
            <option value="">所有活动</option>
            {campaigns.map((campaign) => (
              <option key={campaign.id} value={campaign.id}>
                {campaign.name}
              </option>
            ))}
          </select>
        </div>

        {logs.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            暂无邮件日志
          </p>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>收件人</th>
                    <th>主题</th>
                    <th>状态</th>
                    <th>类型</th>
                    <th>发送时间</th>
                    <th>错误信息</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td>
                        <div>{log.recipient?.email || '-'}</div>
                        {log.recipient?.name && (
                          <div style={{ fontSize: '12px', color: '#999' }}>{log.recipient.name}</div>
                        )}
                      </td>
                      <td style={{ maxWidth: '300px' }}>
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {log.subject}
                        </div>
                      </td>
                      <td>{getStatusBadge(log.status)}</td>
                      <td>
                        {log.is_followup ? (
                          <span className="badge badge-info">Follow-up #{log.followup_number}</span>
                        ) : (
                          <span className="badge badge-secondary">初次</span>
                        )}
                      </td>
                      <td>
                        {log.sent_at ? new Date(log.sent_at).toLocaleString() : '-'}
                      </td>
                      <td>
                        {log.error_message && (
                          <div style={{ maxWidth: '200px', fontSize: '12px', color: '#e74c3c' }}>
                            {log.error_message}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                上一页
              </button>
              <span>第 {page} 页</span>
              <button onClick={() => setPage(page + 1)} disabled={logs.length < 50}>
                下一页
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default EmailLogs;

